export class CompanyModel {
    id: any
    name: string = ''
    register: string = ''
    phone: string = ''
    approved? = 0
    clubMember? = 0
    canPayLater? = 0
    active? = 0;
    town: string = 'Улаанбаатар'
    district: string = ''
    unit: string = ''
    street: string = ''
    /** The picked khoroo from the delivery area list; null = an address saved as free text (or none). */
    deliveryAreaId: number | null = null
    zipcode: string = ''
    parentCompanyId?: number
    childCompanyCount?: number
}